<template lang="html">
  <div class="searchFilter">
    <cm-messages-filter
      class="researchfilter"
      style="position:relative;z-index:10"
      :isPayments="true"
      :received="false">
    </cm-messages-filter>

    <transactions-list
      :filterBy="filterBy"
      v-bind:outMessages="sendboxMessages">
    </transactions-list>
</div>
</template>

<script>
import TransactionsList from '@/pages/requests/TransactionsList.vue'
import MessagesFilter from '@/components/common/Filter.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'sent-rtp',
  components: {
    'transactions-list': TransactionsList,
    'cm-messages-filter': MessagesFilter
  },
  data () {
    return {
      sendboxMessages: [],
      filterBy: '',
      pageCounter: 0,
      noMore: false
    }
  },
  created () {

  },
  mounted () {
    let that = this
    // Désactivation d'évènements
    this.$bus.$off('refresh-cache-bank-accounts')
    this.$bus.$off('refresh-cache-contacts')
    this.$bus.$off('refresh-cache-attachments')
    this.$bus.$off('refresh-cache-account-members')
    this.$bus.$off('refresh-sendbox-list-cache')
    this.$bus.$off('refresh-inbox-on-seen')
    this.$bus.$off('sendbox-filtered')

    // Activation d'évènements
    // Mise à jour des messages en cas de filtrage
    this.$bus.$on('sendbox-filtered', payments => {
      that.updateSendbox(payments)
      that.pageCounter = 0
    })
    // Mise à jour des messages et redirection vers les détails en cas de click sur un message
    this.$bus.on('refresh-sendbox-on-seen', (refPays) => {
      that.updateSendbox(refPays, true)
      loadPage(that, {url: '/payments/transaction-details/'})
    })

    // Rafraichissment des messages (initialisation)
    this.refreshSendbox()

    // Initialisation des paramètres de système de filtrage
    this.$engine.settings.set({msgDirection: 1})
    this.$engine.settings.set({filterType: ''})
    this.$engine.settings.set({filterValue: ''})
  },
  beforeDestroy () {
    // Purge du système de filtrage
    this.$engine.services.payments.filter.cleanFilterCondition()
  },
  computed: {
    // Retourne vrai s'il n'y a pas de message, faux sinon
    emptyBox () {
      return this.sendboxMessages.length === 0
    }
  },

  methods: {
    /**
    * Fonction appelée lors de l'évènement de infinite scroll (lorsque l'on scroll en bas de page)
    * TODO : Remplacer le infinite scroll par la pagination
    * @event
    */
    onInfinite: function (event) {
      if (this.scrollFlag) {
        this.scrollFlag = false
        let that = this
        that.pageCounter = that.pageCounter + 1
        that.$engine.services.payments.update(1, 15, that.pageCounter * 15 + 1, that.$engine.services.payments.filter.getConditionObject())
        .then(resp => {
          this.$bus.emit('paymentsNumber', resp.data.totalPayments)
          // this.paymentsNumber = resp.data.totalPayments
          let payments = resp.data.payments
          if (payments.length > 0) {
            for (let i = 0; i < payments.length; i++) {
              that.sendboxMessages.push(payments[i])
            }
            if (payments.length < 15) {
              this.detachInfinit()
            }
          } else {
            this.detachInfinit()
          }
          this.scrollFlag = true
        })
        .catch(error => {
          errorMessageAlert(error, that)
          this.scrollFlag = true
        })
      }
    },

    /**
     * Actualisation des message (appel à l'API)
     * @param {Boolean} noAttach - détermine si le infinite scroll ne doit PAS être attaché
     */
    refreshSendbox (noAttach = false) {
      const that = this
      this.pageCounter = 0
      this.scrollFlag = true

      that.$engine.services.payments.update(1, 15, 1, that.$engine.services.payments.filter.getConditionObject())
      .then(resp => {
        this.$emit('paymentsNumber', resp.data.totalPayments)
        // this.paymentsNumber = resp.data.totalPayments
        this.updateSendbox(resp.data.payments, noAttach)
        this.$emit('pullToRefreshDone')
        // that.$f7.hidePreloader()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },

    /**
    * Remplace les messages en mémoire par des nouveaux message
    * @param {Array} payments - les nouveaux messages à afficher
    * @param {Boolean} noAttach - détermine si le infinite scroll ne doit PAS être attaché
    */
    updateSendbox (payments, noAttach = false) {
      this.sendboxMessages = payments
      if (payments.length === 15) {
        if (!noAttach) {
          this.attachInfinit()
          // this.attachInfinit()
        }
      } else {
        this.detachInfinit()
        // this.detachInfinit()
      }
    },

    /**
    * Attache le infinite scroll au DOM
    */
    attachInfinit () {
      if (this.$settings.sendboxPreloaderRemoved) {
        this.$$('.infinite-scroll').append(
        '<div class="infinite-scroll-preloader"><div class="preloader"></div></div>'
        )
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({sendboxPreloaderRemoved: false})
      } else {
      }
      this.noMore = false
    },

    /**
    * Détache le infinite scroll du DOM
    */
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({sendboxPreloaderRemoved: true})
      if (!this.emptyBox) this.noMore = true
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// SentRTP.vue?40da2246